import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { getEcsServiceCpuMem } from '../../services'
import { SystemMetricsQueryKey } from '../../../keys'
import {
	GetEcsServiceCpuMemRequest,
	GetEcsServiceCpuMemResponse,
} from '../../../type'

export default function useQueryGetEcsServiceCpuMem(
	params: GetEcsServiceCpuMemRequest,
	props?: UseBaseQueryOptions<GetEcsServiceCpuMemResponse>,
) {
	return useQuery({
		queryKey: [SystemMetricsQueryKey.GetEcsServiceCpuMem, params],
		queryFn: () => getEcsServiceCpuMem(params),
		refetchInterval: 30000, // Refetch every 30 seconds
		...props,
	})
}
